import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  features: string[];
  onLearnMore: () => void;
}

const ServiceCard = ({ icon, title, description, features, onLearnMore }: ServiceCardProps) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-subtle hover:shadow-elevation transition-all duration-300 ease-brand border border-border">
      <div className="flex items-start space-x-4 mb-4">
        <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name={icon as any} size={24} className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-display font-bold text-foreground mb-2">{title}</h3>
          <p className="text-muted-foreground text-sm">{description}</p>
        </div>
      </div>
      <ul className="space-y-2 mb-4">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start space-x-2 text-sm text-foreground">
            <Icon name="CheckCircleIcon" size={16} className="text-success flex-shrink-0 mt-0.5" />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <button
        onClick={onLearnMore}
        className="w-full px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-semibold hover:bg-primary/90 transition-all duration-300 ease-brand"
      >
        Learn More
      </button>
    </div>
  );
};

export default ServiceCard;